import React from "react";

import { useStyles } from "./styles";

export const LocationIcon = ({ color }: LocationIconProps) => {
  const classes = useStyles({ color });

  return (
    <span className={classes.container}>
      <span className={classes.icon} />
    </span>
  );
};

export interface LocationIconProps {
  color: string;
}
